module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "el-form",
    class: [
      _vm.labelPosition ? 'el-form-label-' + _vm.labelPosition : '',
      {
        'el-form-inline': _vm.inline
      }
    ],
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.handleEnter($event)
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-04929666!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/form/src/form.vue
// module id = 604
// module chunks = 0